import React from "react";

import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";

import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiTypography from "components/SuiTypography";

import PropTypes from "prop-types";

const TableTopControls = ({ page, onPageChange, pageSize, onPageSizeChange, totalRows }) => {
  const totalPages = Math.ceil(totalRows / pageSize);

  return (
    <SuiBox display="flex" alignItems="center" gap={2}>
      <FormControl size="small" sx={{ minWidth: 120 }}>
        <Select
          value={pageSize}
          label="Registros"
          onChange={(e) => {
            onPageSizeChange(e.target.value);
            onPageChange(0);
          }}
          sx={{ height: "40px" }}
        >
          <MenuItem value={10}>10 registros</MenuItem>
          <MenuItem value={25}>25 registros</MenuItem>
          <MenuItem value={50}>50 registros</MenuItem>
          <MenuItem value={100}>100 registros</MenuItem>
        </Select>
      </FormControl>
      <SuiTypography variant="button" fontWeight="regular">
        Pág. {page + 1} / {totalPages || 1}
      </SuiTypography>
      <SuiButton
        variant="outlined"
        buttonColor="dark"
        onClick={() => onPageChange(page - 1)}
        disabled={page === 0}
        size="small"
      >
        Anterior
      </SuiButton>
      <SuiButton
        variant="outlined"
        buttonColor="dark"
        onClick={() => onPageChange(page + 1)}
        disabled={page >= totalPages - 1}
        size="small"
      >
        Siguiente
      </SuiButton>
    </SuiBox>
  );
};

TableTopControls.propTypes = {
  page: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  pageSize: PropTypes.number.isRequired,
  onPageSizeChange: PropTypes.func.isRequired,
  totalRows: PropTypes.number.isRequired,
};

export default TableTopControls;
